import { useState, useMemo } from 'react';
import type { ApiEndpoints, QecListEvent } from '@avisoma/shared';
import { Card } from '../../components/Card';
import { DescriptionList, DescriptionTerm, DescriptionDetails } from '../../catalyst/description-list';
import { QECTable } from '../../components/reconstructedDocument/extractionTables/QECTable';
import { ExtractionTableCard } from '../../components/reconstructedDocument/extractionTables/ExtractionTableCard';
import { RowInspectorDialog } from '../../components/reconstructedDocument/extractionTables/RowInspectorDialog';
import { SourceCard } from './SourceCard';
import { StatusPackWarnings } from './StatusPackWarnings';

interface QecListEventsProps {
  response: ApiEndpoints<string>['/api/projects/:id']['GET']['response'];
}

export function QecListEvents({ response }: QecListEventsProps) {
  const data = response.item.data?.qecEvents;
  const rows = data?.qecListEvents;
  const [inspected, setInspected] = useState<QecListEvent | null>(null);

  const pageIdToPosition = useMemo(() => {
    const map = new Map<string, number>();
    data?.pageIds.forEach((pageId, index) => map.set(pageId, index + 1));
    return map;
  }, [data?.pageIds]);

  if (!data || !rows) {
    return null;
  }

  return (
    <div className="space-y-6">
      <SourceCard sources={[{ esn: data.esn, documentId: data.documentId, pageIds: data.pageIds }]}>
        <StatusPackWarnings warnings={data.warnings} />
      </SourceCard>

      <Card
        header={
          <h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">QEC / Accessory List</h2>
        }
      >
        <DescriptionList>
          <DescriptionTerm>Item Count</DescriptionTerm>
          <DescriptionDetails>{rows.length}</DescriptionDetails>
        </DescriptionList>
      </Card>

      <ExtractionTableCard label="QEC / Accessory List" rows={rows} csvTitle="QEC List Events" bodyHeight="project">
        <QECTable rows={rows} pageIdToPosition={pageIdToPosition} onInspect={setInspected} />
      </ExtractionTableCard>

      <RowInspectorDialog
        open={inspected != null}
        onClose={() => setInspected(null)}
        title="QEC / Accessory row"
        data={inspected}
      />
    </div>
  );
}
